module.exports = __webpack_public_path__ + "static/VG5000-Regular_web-d304ef6cbb0dd7f84375d8e6bf6d665a.eot";